/** Up to two initials of a name: first and last word, e.g. "Acme Bygg AB" -> "AA" */
export default function getInitials(name: string | null | undefined) {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean)

  if (!words.length) {
    return ''
  }

  const first = words[0][0]
  const last = words.length > 1 ? words[words.length - 1][0] : ''

  return `${first}${last}`.toLocaleUpperCase()
}
